export default __webpack_public_path__ + "odl_logo.png";